import React from 'react';

const Reports = () => {
  return (
    <div>
      <h1>Reports Page</h1>
      <p>Content for the Reports page.</p>
    </div>
  );
};

export default Reports;
